"use strict";

require("core-js/modules/es6.number.constructor");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getExemptionSummary;

function getExemptionSummary() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  try {
    var totals = {};
    var exemptions = data.exemptions || []; // If we didn't get exemptions, pull from assets array

    if (data.assets && data.exemptions == null) {
      data.assets.forEach(function (a) {
        a.exemptions.forEach(function (e) {
          return exemptions.push(e);
        });
      });
    } // Compile values being used


    exemptions.forEach(function (e) {
      if (e.law) {
        if (totals[e.law] == null) totals[e.law] = 0;
        totals[e.law] += Number(e.value || 0);
      }
    });
    return {
      exemptions: exemptions,
      totals: totals
    };
  } catch (e) {
    throw e;
  }
}